export function trackPixelEvent(
  eventName: string,
  params?: Record<string, any>,
) {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;(window as any).fbq('track', eventName, params)
  }
}

// Standard Meta Ads events for e-commerce
export function trackViewContent() {
  trackPixelEvent('ViewContent', {
    content_name: 'De 0 a Influencer',
    content_type: 'product',
    content_ids: ['46518849142973'],
    value: 14990,
    currency: 'ARS',
  })
}

export function trackAddToCart() {
  trackPixelEvent('AddToCart', {
    content_name: 'De 0 a Influencer',
    content_type: 'product',
    content_ids: ['46518849142973'],
    value: 14990,
    currency: 'ARS',
  })
}

export function trackInitiateCheckout() {
  trackPixelEvent('InitiateCheckout', {
    content_name: 'De 0 a Influencer',
    content_type: 'product',
    content_ids: ['46518849142973'],
    value: 14990,
    currency: 'ARS',
    num_items: 1,
  })
}

export function trackLead() {
  trackPixelEvent('Lead', {
    content_name: 'De 0 a Influencer',
  })
}
